import { createGlobalStyle } from 'styled-components';
import { inlineAppMenuStyles } from './InlineAppMenuStyles.styled';
import { horizontalAppMenuStyles } from './HorizontalAppMenuStyles.styled';

export const GlobalStyle = createGlobalStyle`
      ${horizontalAppMenuStyles}
      ${inlineAppMenuStyles}
`;
